import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {TeamMember} from '../../../services';

export const useGotoMember = (teamId: number) => {
  const history = useHistory();
  return useCallback(
    (member: TeamMember) => {
      history.push(`/member/${teamId}/${member.membershipId}`);
    },
    [history, teamId],
  );
};
